<template>
    <el-row class="footer-row">
      <el-col :span="20" :offset="2" class="important-col">
        <h2 class="fontColorRed">{{importantTipsTitle}}</h2>
        <div><span class="fontColorRed">{{importantTipsTitle}} </span>{{importantTipsContent}}</div>
      </el-col>
      <el-col>
        <copyOpenWC></copyOpenWC>
<!--        <span>友情链接</span><br>-->
<!--        <span>西雅图高端私人会所 All Rights Reserved</span><br>-->
<!--&lt;!&ndash;        <span><a href="http://incall365.com">被全球外围网评选为最佳外围公司</a></span>&ndash;&gt;-->
<!--        <span><a href="#">被全球外围网评选为最佳外围公司</a></span>-->
      </el-col>
    </el-row>
</template>

<script>
import copyOpenWC from "./copyOpenWC";
export default {
  components: {
    copyOpenWC
  },
  data () {
    return {
        wechatImg:require('../assets/wechatImage.jpg'),
        anImg:require('../assets/icon/an.jpg'),
        importantTipsTitle:"重要通知",
        importantTipsContent:"以下是桃桃善意的提醒，请千万不要留我们女孩任何的联系方式，一经发现桃桃将从此不再接待，也会立即与该女孩停止合作，感谢您对我们工作的理解。因为之前发生过有客户与女孩之间互留联系方式，女孩借机玩弄客户感情并索求高额礼物与钱财然后消失，客户来找我理论，请大家在我们这里寻开心就算了，不要互留联系方式延伸到外面，从此以后我们将不再受理类似事件，请不要给彼此添加不必要的麻烦，谢谢各位的配合，愿您在桃桃家的每一次邂逅都是美好的回忆。"
    }
  }
}
</script>

<style  scoped>
  .footer-row{padding-bottom:0;margin-bottom:0;padding-top: 30px;;
    color: #cfcfcf;
    /*background: #3d4049;*/
    /*background-image: -webkit-gradient(linear,left top, left bottom,from(#f09cab), to(#f787c9));*/
    /*background-image: linear-gradient(to bottom,#f09cab, #f787c9);*/
    background-image: -webkit-gradient(linear,left top, left bottom,from(#1a1a1a), to(#131313));
    background-image: linear-gradient(to bottom,#1a1a1a, #131313);
    text-align: center;font-size: 14px;}
  .footer-row a{color: white;}
  .important-col{margin-bottom: 2.5rem;}
  .important-col>div{font-size: 1.15rem;}
  .important-col>h2{font-weight: bold;}
  .fontColorRed{color:red;}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue